// actions
import {
  SUPERCHARGERS_FETCH_REQUEST,
  SUPERCHARGERS_FETCH_SUCCESS,
  SUPERCHARGERS_FETCH_FAILURE,
  SUPERCHARGERS_UPDATE_CHARGING,
  SUPERCHARGERS_HYRDRATE_BODY,
  SUPERCHARGERS_UPDATE_ROUTECHARGERS,
  SUPERCHARGERS_UPDATE_CHARGERS,
} from './actions';

const Superchargers = (state = {
  isLoading: false,
  superchargers: [], // TODO: maybe rename to "chargingNetwork"
  chargingNeeded: true,
  noChargers: false,
  body: '',
  routechargers: [], // TOOD: maybe rename to "superchargers" or move it to directions
}, action) => {
  switch (action.type) {
    case SUPERCHARGERS_FETCH_REQUEST:
      return {
        ...state,
        isLoading: true,
      };
    case SUPERCHARGERS_FETCH_SUCCESS:
      return {
        ...state,
        isLoading: false,
        superchargers: action.superchargers,
      };
    case SUPERCHARGERS_FETCH_FAILURE:
      return {
        ...state,
        isLoading: false,
      };
    case SUPERCHARGERS_UPDATE_CHARGING:
      return {
        ...state,
        chargingNeeded: action.charging,
      };
    case SUPERCHARGERS_UPDATE_CHARGERS:
      return {
        ...state,
        noChargers: action.noChargers,
      };
    case SUPERCHARGERS_HYRDRATE_BODY:
      return {
        ...state,
        body: action.body,
      };
    case SUPERCHARGERS_UPDATE_ROUTECHARGERS:
      return {
        ...state,
        routechargers: action.routechargers,
      };
    default:
      return state;
  }
};

export default Superchargers;
